module.exports = __webpack_public_path__ + "media/images/menu-connect-ssp-active-icon-5989596e2aa24546566e2d1e2bafe4db.svg";